<template>

<div>

    
    <div class="list-loader-outer">
        <transition name="loader-fade">
            <div class="list-loader" v-if="loading">
                <div class="loader"></div>
            </div>
        </transition>
    </div>

    <h1>Månadsredovisning</h1>

    <div class="searchbar">

        <div>

                <div class="block freetext" v-bind:class="{ active: search.text != '' && search.text != null }">
                    
                    <input class="form-control" v-on:keyup="updateQuery()" v-model="search.text" placeholder="Sök period t ex 2017-01" />

                </div>


                <a class="btn btn-default" v-bind:class="{ disabled: accounting == true  }" v-on:click="account()" v-if="periods != null">
                    <i class="fa fa-circle-o-notch fa-spin" v-if="accounting == true"></i> Redovisa
                </a>

                <div class="block" style="float: right; margin-right: 15px;" v-if="periods != null">

                    <select class="form-control" v-model="selectedPeriod">
                        <option
                            v-for="period in periods" 
                            v-bind:value="period.id">
                            {{ period.listPeriod }}
                        </option>
                    </select>

                </div>

            
    <br clear="all">

        </div>

    </div>

</div>


</template>



<script>

    export default {
        props: {
            query: {
                required: true
            },
            loading: {}
        },
        created: function() {

            console.log('running created');
            this.getPeriods();

        },
        data: function () {
            return {
                search: {},
                periods: null,
                selectedPeriod: null,
                months: [
                    { value: '1', text: 'Januari' },
                    { value: '2', text: 'Februari' },
                    { value: '3', text: 'Mars' },
                    { value: '4', text: 'April' },
                    { value: '5', text: 'Maj' },
                    { value: '6', text: 'Juni' },
                    { value: '7', text: 'Juli' },
                    { value: '8', text: 'Augusti' },
                    { value: '9', text: 'September' },
                    { value: '10', text: 'Oktober' },
                    { value: '11', text: 'November' },
                    { value: '12', text: 'December' }
                ],
                selectedMonth: new Date().getMonth() + 1,
                currentMonth: new Date().getMonth() + 1,
                accounting: false,
            }
        },
        methods: {

            updateQuery: function() {

                this.$emit('search', this.search);

            },

            getPeriods: function() {

                var self = this;

                console.log('running getPeriods');

                this.$http.post('/accounting/getPeriods', {  }).then((response) => {


                    console.log('got periods');
                    console.log(response.body);


                    if(response.body.length > 0) {

                        self.periods = response.body;
                        self.selectedPeriod = self.periods[0].id;
                        self.accounting = false

                    } else {

                        self.periods = null;
                        self.selectedPeriod = null;

                    }


                }, (response) => {
                    console.log(JSON.stringify(response));
                });

            }, 

            account: function() {

                var self = this;


                if(self.accounting == true) {
                    return;
                }

                self.accounting = true

                console.log('time to account');
                console.log(self.selectedPeriod);

                

                this.$http.post('/accounting/account', { period_id: self.selectedPeriod }).then((response) => {

                    console.log(response.body);

                    self.getPeriods();

                    self.$emit('search', self.search);


                }, (response) => {
                    console.log(JSON.stringify(response));
                });

            

            }


        },
        watch: {
            query: function() {

                this.search = this.query;

            }
        }
    }

</script>